import axios from "axios";
import { useState, useEffect } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import imge from "../assets/images/YLAC Digital.3021a8625f44a24fbbeb.png";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faEyeSlash,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Constants from "../common/Constants";

const style = {
  padding: "16px 18px",
  border: "2px dotted black",
  borderRadius: "25px",
  outline: "none",
  background: "transparent",
  appearance: "none",
};

const SignUp = () => {
  const [register, setRegister] = useState({
    name: "",
    genderId: "",
    email: "",
    password: "",
    age: "",
    selectedGrade: "Grade",
    selectedGradeId: "",
    selectedCity: "Select City",
    selectedCityId: "",
  });
  const [loading, setLoading] = useState(false);
  const [grades, setGrades] = useState([]);
  const [cities, setCities] = useState([]);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [citySearch, setCitySearch] = useState("");
  const navigate = useNavigate();
  const passwordVisiblility = () => {
    setShowPassword(!showPassword);
  };
  const filteredCities = cities.filter((city) =>
    city.name.toLowerCase().includes(citySearch.toLowerCase())
  );

  const GRADE_API = `${Constants.BASE_URL}/student-public-grade-list`;
  const CITY_API = `${Constants.BASE_URL}/student-public-city-list`;
  const REGISTER_API = `${Constants.BASE_URL}/student-register`;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [gradeRes, cityRes] = await Promise.all([
          axios.get(GRADE_API),
          axios.get(CITY_API),
        ]);

        if (gradeRes.status !== 200) throw new Error(`Unexpected status: ${gradeRes.status}`);
        if (gradeRes.status !== 200) throw new Error(`Unexpected status: ${gradeRes.status}`);
        const gradeData = gradeRes.data.class_summary || [];
        const cityData = cityRes.data.cities || [];

        setGrades(gradeData);
        setCities(cityData);
      } catch (error) {
        console.error("Error fetching grades or cities:", error);
        toast.error("error:", error || error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);



  const handleChange = (field, value) => {
    setRegister((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" })); // Clear error when typing
  };

  const handleGradeSelect = (gradeTitle) => {
    const selected = grades.find((g) => g.title === gradeTitle);
    setRegister((prev) => ({
      ...prev,
      selectedGrade: gradeTitle,
      selectedGradeId: selected?.id || "",
    }));
  };
  const handleCitySelect = (cityName) => {
    const selected = cities.find((c) => c.name === cityName);
    setRegister((prev) => ({
      ...prev,
      selectedCity: cityName,
      selectedCityId: selected?.id || "",
    }));
    setCitySearch("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const formData = new FormData();
      formData.append("name", register.name);
      formData.append("email", register.email);
      formData.append("age", register.age);
      formData.append("gender_id", register.genderId);
      formData.append("password", register.password);
      formData.append("grade_id", register.selectedGradeId);
      formData.append("master_city_id", register.selectedCityId);

      const response = await axios.post(REGISTER_API, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-api-key": "fc9f4a47-4f7f-41ba-a656-d30e0009d6f0",
        },
      });
      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      const apiData = response.data;

      if (apiData?.status === 1) {
        toast.success(apiData.message);

        setRegister({
          name: "",
          genderId: "",
          email: "",
          password: "",
          age: "",
          selectedGrade: "Grade",
          selectedGradeId: "",
          selectedCity: "Select City",
          selectedCityId: "",
        });
        setTimeout(() => {
          navigate("/");
        }, 5000);
      } else if (apiData?.errors) {
        const fieldErrors = {};
        Object.entries(apiData.errors).forEach(([field, msgs]) => {
          fieldErrors[field] = msgs[0];
          toast.error(msgs[0]);
        });
        setErrors(fieldErrors);
      } else if (apiData?.status === 400) {
        toast.error(apiData.message);
      }
    } catch (error) {
      console.error("Registration error:", error);
      toast.error(error?.response?.data?.message || "Something went wrong.");
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!register.name.trim()) newErrors.name = "Please enter your name";
    if (!register.genderId) newErrors.genderId = "Please select your gender";
    if (!register.selectedGradeId)
      newErrors.selectedGrade = "Please select your grade";
    if (!register.email.trim()) newErrors.email = "Please enter your email";
    if (!register.password.trim())
      newErrors.password = "Please enter your password";
    if (!register.age.trim()) newErrors.age = "Please enter your age";
    if (!register.selectedCityId)
      newErrors.selectedCity = "Please select your city";

    setErrors(newErrors);
    Object.values(newErrors).forEach((msg) => toast.error(msg));
    return Object.keys(newErrors).length === 0;
  };

  return (
    <>
      <div
        className="d-flex align-items-center formParentMain"
        style={{
          background: "#F7F7F7",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Container>
          <Row className="justify-content-between align-items-center">
            <Col lg={4} xs={12} className="text-center">
              <img src={imge} alt="Logo" />
            </Col>
            <Col lg={6} xs={12}>
              <form onSubmit={handleSubmit}>
                <div className="w-100 mb-3 mt-1">
                  <input
                    type="text"
                    className="w-100 custom-input"
                    style={style}
                    placeholder="Name"
                    value={register?.name}
                    onChange={(e) => handleChange("name", e.target.value)}
                  />
                </div>

                <div className="w-100 mb-3 position-relative">
                  <select
                    className="w-100 select_option"
                    style={style}
                    value={register.genderId}
                    onChange={(e) => handleChange("genderId", e.target.value)}
                  >
                    <option value="">Select Gender</option>
                    <option value="1">Male</option>
                    <option value="2">Female</option>
                    <option value="3">Other</option>
                    <option value="4">Prefer not to say</option>
                  </select>
                  <span className="passIcon">
                    <FontAwesomeIcon icon={faChevronDown} />
                  </span>
                </div>

                <div className="w-100 dropdownInput position-relative">
                  <Dropdown onSelect={handleGradeSelect}>
                    <Dropdown.Toggle
                      id="gradeDropdown"
                      aria-expanded="false"
                      className="w-100 custom-input-toggle text-start p-0"
                      variant="light"
                      disabled={loading}
                    >
                      {register.selectedGrade}
                      <span className="dropdownIcon">
                        <FontAwesomeIcon icon={faChevronDown} />
                      </span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="w-100" aria-labelledby="gradeDropdown">
                      {grades.map((grade) => (
                        <Dropdown.Item key={grade.id} eventKey={grade.title}>
                          {grade.title}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>

                </div>
                <div className="mb-3 pt-1 text-start">
                  <span style={{ color: "gray" }} className="fs-6 fw-medium">
                    If you are no longer in school or have graduated, please
                    select "Above 18"
                  </span>
                </div>
                <div className="w-100 mb-3">
                  <input
                    type="email"
                    className="w-100 custom-input"
                    style={style}
                    placeholder="Email address"
                    pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                    value={register?.email}
                    onChange={(e) => handleChange("email", e.target.value)}
                  />
                </div>
                <div className="w-100 mb-3 position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="w-100 custom-input"
                    style={style}
                    placeholder="Password"
                    value={register?.password}
                    onChange={(e) => handleChange("password", e.target.value)}
                  />
                  <span className="passIcon" onClick={passwordVisiblility}>
                    {showPassword ? (
                      <FontAwesomeIcon icon={faEyeSlash} />
                    ) : (
                      <FontAwesomeIcon icon={faEye} />
                    )}
                  </span>
                </div>
                <div className="w-100 mb-3">
                  <input
                    type="number"
                    min={1}
                    className="w-100 custom-input"
                    style={style}
                    placeholder="Age"
                    value={register?.age}
                    onChange={(e) => handleChange("age", e.target.value)}
                  />
                </div>
                <div className="w-100 mb-3 position-relative dropdownInput">
                  <Dropdown onSelect={handleCitySelect}>
                    <Dropdown.Toggle
                      className="w-100 custom-input-toggle text-start p-0"
                      variant="light"
                      style={style}
                      disabled={loading}
                    >
                      {register.selectedCity}
                      <span className="dropdownIcon">
                        <FontAwesomeIcon icon={faChevronDown} />
                      </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="w-100">
                      <div className="px-2 py-1">
                        <input
                          type="text"
                          placeholder="Search City"
                          className="form-control selectCities"
                          value={citySearch}
                          onChange={(e) => setCitySearch(e.target.value)}
                          autoFocus
                        />
                      </div>
                      <div className="citiesBox">
                        {filteredCities.length > 0 ? (
                          filteredCities.map((city) => (
                            <Dropdown.Item key={city.id} eventKey={city.name}>
                              {city.name}
                            </Dropdown.Item>
                          ))
                        ) : (
                          <Dropdown.Item disabled>
                            No cities found
                          </Dropdown.Item>
                        )}
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>

                  {errors.selectedCity && (
                    <span className="error">{errors.selectedCity}</span>
                  )}
                </div>

                <div className="signBtn mb-3 text-center">
                  <button
                    type="submit"
                    style={{
                      border: "0px",
                      outline: "none",
                      padding: "15px 100px",
                      borderRadius: "40px",
                      backgroundColor: "#E86979",
                      color: "#1E315F",
                      fontSize: "22px",
                      fontWeight: "500",
                    }}
                  >
                    Sign Up
                  </button>
                </div>

                <div className="ac-reg w-100 mb-1 text-center">
                  <p className="mb-0">Already have an account registered?</p>
                </div>
                <div className="log-link text-center">
                  <Link to="/" className="lik-item">
                    Login Here
                  </Link>
                </div>
              </form>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default SignUp;
